import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Landing = () => import('@/views/pages/Landing')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

const Setting = () => import('@/views/settings/Setting')
const SettingEdit = () => import('@/views/settings/SettingEdit')
const Equipment = () => import('@/views/equipments/Equipment')
const EquipmentList = () => import('@/views/equipments/EquipmentList')
const Camera = () => import('@/views/general/Camera')

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})


router.beforeEach((to, from, next) => {
  var isAuth = auth.check();
  console.log(isAuth)
  if (!isAuth) {
    if (to.name == 'Login') {
      next();
    }
    else {
      next({ name: 'Login' });
    }
  }
  else {
    next();
  }
})

export default router

function configRoutes() {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'users',
          meta: { label: 'Users' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: 'user/:id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            },
            {
              path: 'user',
              name: 'User',
              component: User
            },
          ]
        },
        {
          path: 'settings',
          meta: { label: 'Settings'},
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'settingEdit',
              name: 'SettingEdit',
              component: SettingEdit
            },
            {
              path: '',
              name: 'Setting',
              component: Setting
            },

          ]
        },
        {
          path: 'equipments',
          meta: { label: 'Equipments'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            // {
            //   path: '',
            //   name: 'Equipment',
            //   component: Equipment
            // },

            {
              path: 'equipment/:id',
              name: 'equipmentById',
              component: Equipment
            },
            {
              path: 'equipment',
              name: 'equipment',
              component: Equipment
            },
            {
              path: 'equipmentList',
              name: 'equipmentList',
              component: EquipmentList
            },


          ]
        },
        {
          path: 'cameras',
          meta: { label: 'Cameras'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Camera',
              component: Camera
            },
          ]
        },
        
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'landing',
          name: 'Landing',
          component: Landing
        },
      ]
    }
  ]
}
